module.exports = __webpack_public_path__ + "static/media/how_we_use_your_personal_data.706fb4a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/how_we_use_your_personal_data.jpg
// module id = 222
// module chunks = 0